import axios from "axios";
import { APP_SETTINGS } from "../../config";

  function getMonthlySummaryProjectsReportApi(params) {
    return axios.post(
      `${APP_SETTINGS.API_PATH.REPORT.getMonthlySummaryProjectsReport}`,
      params
    );
  }

  function getMonthlySummaryUsersReportApi(params) {
    return axios.post(
      `${APP_SETTINGS.API_PATH.REPORT.getMonthlySummaryUsersReport}`,
      params
    );
  }

  export {
    getMonthlySummaryProjectsReportApi,
    getMonthlySummaryUsersReportApi,
  };